export function dataInRequest(params = {}) {
  return {
    type: '@raizenerrologintegracao/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@raizenerrologintegracao/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@raizenerrologintegracao/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@raizenerrologintegracao/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@raizenerrologintegracao/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@raizenerrologintegracao/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@raizenerrologintegracao/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@raizenerrologintegracao/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@raizenerrologintegracao/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@raizenerrologintegracao/RECORD_FILTERING',
    payload: { params },
  };
}
